module.exports = __webpack_public_path__ + "20a5f3b1b1530a7a3864d5d3b67a8f6d.MP3";